import React, { useEffect, useState } from "react";
import * as LucideIcons from "lucide-react";
import { useApp, t } from "@/lib/AppContext";
import { api, resolveImg } from "@/lib/api";
import SectionLabel from "@/components/SectionLabel";

export default function Services() {
  const { content, settings } = useApp();
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then(r => setServices(r.data || [])); }, []);
  const bg = settings?.bg_image_urls?.services;

  return (
    <div data-testid="services-page">
      <section className="relative py-16 md:py-24 section-on-dark">
        <div className="absolute inset-0">
          {bg && <img src={resolveImg(bg)} alt="" className="w-full h-full object-cover" />}
          <div className="absolute inset-0" style={{ background: "rgba(28,58,107,0.85)" }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <SectionLabel light>{t(content, "services.label", "")}</SectionLabel>
          <h1 className="section-heading text-white mt-4">{t(content, "services.title", "")}</h1>
          <p className="text-white/75 mt-3 max-w-2xl">{t(content, "services.subtitle", "")}</p>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-[var(--color-bg-primary)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map(s => {
              const Icon = LucideIcons[s.icon] || LucideIcons.Wrench;
              return (
                <div key={s.id} className="bg-white p-7 rounded-[var(--radius-lg)] border-t-[3px]" style={{ borderColor: "var(--color-primary)", boxShadow: "var(--shadow-card)" }} data-testid={`service-card-${s.id}`}>
                  <div className="w-14 h-14 rounded-md flex items-center justify-center mb-5" style={{ background: "rgba(28,58,107,0.08)" }}>
                    <Icon size={26} style={{ color: "var(--color-secondary)" }} />
                  </div>
                  <h3 className="font-headings font-bold text-xl mb-3">{s.title}</h3>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">{s.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
